import { GET_USER_PHONES_REQUEST, GET_USER_PHONES_REQUEST_SUCCESS, GET_USER_PHONES_REQUEST_FAILURE } from '../../constants/user_phones.constants';

export const getUserPhonesRequest = _id => ({ type: GET_USER_PHONES_REQUEST, _id });
export const getUserPhonesRequestSuccess = payload => ({ type: GET_USER_PHONES_REQUEST_SUCCESS, payload });
export const getUserPhonesRequestFailure = error => ({ type: GET_USER_PHONES_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_phones_actions/get_user_phones.actions.js